import { createAsyncThunk } from "@reduxjs/toolkit";
import { ForecastOption } from "../../../../../../services/cloudchipr.api";
import { setWidgetSetup } from "../../../../dashboardsSlice";
import { getCostBreakdownV2WidgetSetupDataThunk } from "../getCostBreakdownV2WidgetSetupDataThunk";
import { RootState } from "../../../../../store";
import { costBreakdownV2WidgetSetupSelector } from "../../../../selectors/setups/cost-breakdown-v2/costBreakdownV2WidgetSetupSelector";

export const costBreakdownV2ForecastChangeThunk = createAsyncThunk(
  "dashboards/costBreakdownForecastChange",
  async (forecastOption: ForecastOption, { dispatch, getState }) => {
    const state = getState() as RootState;
    const existingSetup = costBreakdownV2WidgetSetupSelector(state);

    if (!existingSetup) {
      return;
    }
    dispatch(
      setWidgetSetup({
        ...existingSetup,
        forecastOption,
      }),
    );

    dispatch(getCostBreakdownV2WidgetSetupDataThunk());
  },
);
